<div class="active-filters">
  <div class="filters-row">
    <span class="filters-label">Filtros</span>

    <!-- Atalhos dinâmicos: o período é derivado de "hoje" a cada consulta, então
         "Esta semana" continua certo na semana que vem sem ninguém mexer. -->
    <div class="period-shortcuts">
      @for (atalho of atalhos; track atalho) {
        <button
          type="button"
          class="period-shortcut"
          [class.period-shortcut--active]="isAtalhoAtivo(atalho)"
          [attr.aria-pressed]="isAtalhoAtivo(atalho)"
          (click)="onAtalhoClick(atalho)">
          {{ periodoLabels[atalho] }}
        </button>
      }
    </div>

    @if (chips.length > 0) {
      <div class="filter-count mobile-only">
        <i class="pi pi-filter"></i>
        <span>{{ chips.length }} {{ chips.length === 1 ? 'filtro ativo' : 'filtros ativos' }}</span>
      </div>
    }

    <div class="chips-container desktop-only">
      @for (chip of chips; track chip.key) {
        <p-chip [removable]="chip.removable" (onRemove)="onRemoveChip(chip)">
          <span class="chip-content">
            <strong>{{ chip.label }}:</strong>
            {{ chip.value }}
          </span>
        </p-chip>
      }
      @if (chips.length === 0) {
        <span class="no-filters">Nenhum filtro aplicado</span>
      }
    </div>

    <div class="filters-actions">
      <ng-content select="[filtersActionsLeft]"></ng-content>

      <p-button
        label="Alterar filtros"
        icon="pi pi-filter"
        [text]="true"
        size="small"
        (onClick)="onEditFilters()" />
    </div>
  </div>

  <app-saved-filter-chips
    [enableSavedFilters]="enableSavedFilters"
    [savedFilters]="savedFilters"
    [activeSavedFilterId]="activeSavedFilterId"
    (applyFilter)="onApplySavedFilter($event)"
    (deactivateFilter)="deactivateSavedFilter.emit()"
    (deleteFilter)="onDeleteSavedFilter($event)" />
</div>
